// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminComplianceFlags = (client) => ({
    /**
     * `GET /admin/compliance-flags`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminComplianceFlagsList
     * @source packages/modules/b2c-core/src/api/admin/compliance-flags/route.ts
     */
    list: (query, headers) => client.fetch("/admin/compliance-flags", { method: "GET", query, headers }),
    /**
     * `POST /admin/compliance-flags/:id/resolve`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminComplianceFlagsResolveCreate
     * @source packages/modules/b2c-core/src/api/admin/compliance-flags/[id]/resolve/route.ts
     */
    updateResolve: (id, body, query, headers) => client.fetch(buildPath("/admin/compliance-flags/:id/resolve", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=compliance-flags.js.map